export type AssessmentUnitFormState = {
  currentState?: string;
  futureState?: string;
  currentStatusDescription?: string;
  futureStatusDescription?: string;
};

export type AssessmentNavRatingStatus = 'none' | 'partial' | 'complete';

export function getAssessmentUnitRatingStatus(
  state: AssessmentUnitFormState | null | undefined
): AssessmentNavRatingStatus {
  if (!state) return 'none';

  const hasCurrent = Boolean(state.currentState);
  const hasFuture = Boolean(state.futureState);
  const hasCurrentComment = Boolean(state.currentStatusDescription?.trim());
  const hasFutureComment = Boolean(state.futureStatusDescription?.trim());

  if (hasCurrent && hasFuture && hasCurrentComment && hasFutureComment) {
    return 'complete';
  }

  if (hasCurrent || hasFuture || hasCurrentComment || hasFutureComment) {
    return 'partial';
  }

  return 'none';
}
